import { render, staticRenderFns } from "./PdfmdpsepIndextab3.vue?vue&type=template&id=0408cc05"
import script from "./PdfmdpsepIndextab3.vue?vue&type=script&lang=js"
export * from "./PdfmdpsepIndextab3.vue?vue&type=script&lang=js"
import style0 from "./PdfmdpsepIndextab3.vue?vue&type=style&index=0&id=0408cc05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports